// Pure pass-through: receives props from reports-tab.js and forwards to sections.
// Known bugs preserved from original JSX: "bg-ornage-400" typo in Section 2;
// Section 5's Positive cell has a self-closing span with value outside the span.

import React from "react";
import { UsingAssistSection } from "./using-assist-section";
import { SentimentByQuestionSection } from "./sentiment-by-question-section";
import { KeyphrasesSection } from "./keyphrases-section";
import { SentimentAnalysisSection } from "./sentiment-analysis-section";
import { RespondentSentimentSection } from "./respondent-sentiment-section";

export function AssistTab(props) {
    return (
        <div className="flex flex-col gap-3">
            <UsingAssistSection />
            <SentimentByQuestionSection
                questionTotalSentimentData={props.questionTotalSentimentData}
                questionTotalSentimentPage={props.questionTotalSentimentPage}
                setQuestionTotalSentimentPage={props.setQuestionTotalSentimentPage}
            />
            <KeyphrasesSection
                sentimentByKeyphrase={props.sentimentByKeyphrase}
                keyphraseSentiment={props.keyphraseSentiment}
                setKeyphraseSentiment={props.setKeyphraseSentiment}
                keyphrasesPage={props.keyphrasesPage}
                setKeyphrasesPage={props.setKeyphrasesPage}
                setResponseSentimentIdList={props.setResponseSentimentIdList}
                setShowResponsesSentimentListDialog={props.setShowResponsesSentimentListDialog}
            />
            <SentimentAnalysisSection
                questionResponsesSentiment={props.questionResponsesSentiment}
                questionSentimentIndex={props.questionSentimentIndex}
                setQuestionSentimentIndex={props.setQuestionSentimentIndex}
            />
            <RespondentSentimentSection
                respondentSentimentData={props.respondentSentimentData}
                respondentSentimentPage={props.respondentSentimentPage}
                setRespondentSentimentPage={props.setRespondentSentimentPage}
                setResponseSentimentListId={props.setResponseSentimentListId}
                setShowRespondentResponseSentimentListDialog={props.setShowRespondentResponseSentimentListDialog}
            />
        </div>
    );
}
